module.exports = __webpack_public_path__ + "img/logos_sp.a720506.png";